module.exports = __webpack_public_path__ + "images/curriculum-bg.jpg";